import './PolicyStyles.css';
import { exportToWord } from '../utils/exportToWord';

const TemporaryAgencyWorkerPolicy = ({
  clientName,
  companyNumber,
  clientAddress,
  effectiveDate,
  hrContact,
  agencyContact,
}) => {
  const handleExportToWord = () => {
    const policyContent = document.getElementById('policy-content');
    exportToWord(policyContent.innerHTML, "Temporary_Agency_Worker_Policy.docx");
  };

  return (
    <div className="policy-container" id="policy-content">
      <h3 className="policy-title">Temporary Worker / Agency Worker Policy</h3>

      <p className="policy-details"><strong>Company Name:</strong> {clientName || "[Insert Company Name]"}</p>
      <p className="policy-details"><strong>Company Number:</strong> {companyNumber || "[Insert Company Number]"}</p>
      <p className="policy-details"><strong>Company Address:</strong> {clientAddress || "[Insert Company Address]"}</p>
      <p className="policy-details"><strong>Policy Effective Date:</strong> {effectiveDate || "[Insert Effective Date]"}</p>

      <h4 className="section-title">1. Purpose</h4>
      <p className="section-content">
        This policy sets out the framework for managing temporary and agency workers engaged by {clientName || "the Company"}, ensuring compliance with the Agency Workers Regulations 2010 and employment law.
      </p>

      <h4 className="section-title">2. Scope</h4>
      <p className="section-content">
        Applies to all temporary, agency, and fixed-term workers engaged through employment agencies or similar providers.
      </p>

      <h4 className="section-title">3. Pre-Engagement Requirements</h4>
      <ul>
        <li>All temporary or agency drivers must agree to a DVLA licence check prior to commencing work.</li>
        <li>Drivers must consent to random and pre-employment drug and alcohol testing in line with company policy and legal requirements.</li>
        <li>Temporary and agency workers are required to sign this policy before starting work.</li>
        <li>All drivers must receive, review, and sign a copy of the company’s Driver Handbook as part of their induction process.</li>
      </ul>

      <h4 className="section-title">4. Rights and Entitlements</h4>
      <ul>
        <li>Temporary and agency workers are entitled to the same basic working conditions as permanent employees after a 12-week qualifying period, including pay, working hours, and rest breaks.</li>
        <li>Access to collective facilities and amenities is provided equally.</li>
        <li>Workers will receive clear information about their roles, pay, and terms of engagement before starting work.</li>
      </ul>

      <h4 className="section-title">5. Responsibilities</h4>
      <ul>
        <li>The Company ensures fair treatment, health and safety compliance, and supports integration within teams.</li>
        <li>Temporary and agency workers must adhere to company policies, procedures, and standards.</li>
        <li>Agencies must provide suitable, qualified workers and comply with relevant legal obligations.</li>
      </ul>

      <h4 className="section-title">6. Health & Safety</h4>
      <p className="section-content">
        Temporary and agency workers will receive appropriate health and safety training and information relevant to their work environment.
      </p>

      <h4 className="section-title">7. Induction and Training</h4>
      <p className="section-content">
        The Company provides an induction covering company policies, procedures, and job-specific training for all temporary and agency workers.
      </p>

      <h4 className="section-title">8. Communication</h4>
      <p className="section-content">
        Open communication channels will be maintained to address any issues or concerns raised by temporary and agency workers promptly.
      </p>

      <h4 className="section-title">9. Termination of Engagement</h4>
      <p className="section-content">
        The terms of engagement, including notice periods and termination procedures, will be clearly outlined and adhered to by all parties.
      </p>

      <h4 className="section-title">Contact Information</h4>
      <p><strong>Human Resources:</strong> {hrContact || "[Insert Contact]"}</p>
      <p><strong>Agency Contact:</strong> {agencyContact || "[Insert Contact]"}</p>

      <h4 className="section-title">Employee Acknowledgment and Signature</h4>
      <p>I confirm that I have read, understood, and agree to comply with the Temporary Worker / Agency Worker Policy, including pre-employment licence checks, drug and alcohol testing, and receipt of the Driver Handbook.</p>
      <p>Worker Name: _________________________</p>
      <p>Signature: _________________________</p>
      <p>Date: _________________________</p>

      <h4 className="section-title">Management Approval and Signature</h4>
      <p>This policy has been approved by senior management and is now in effect.</p>
      <p>Manager/Officer Name: _________________________</p>
      <p>Title: _________________________</p>
      <p>Signature: _________________________</p>
      <p>Date: _________________________</p>

      <div className="mt-4 text-center">
        <button
          onClick={handleExportToWord}
          className="bg-green-600 text-white px-6 py-2 rounded hover:bg-green-700 transition"
        >
          Export to Word
        </button>
      </div>
    </div>
  );
};

export default TemporaryAgencyWorkerPolicy;

